<template>
    <div class="rightTop">
        <!-- <hd-tit :title="'成交趋势'" :ENtitle="'Transaction  trend'"></hd-tit> -->

        <div class="trendClass">
            <div class="filterBox"></div>
            <p class="title">平台入住率</p>
            <div id="lineCharts" style="width: 420px; height: 260px"></div>
        </div>
    </div>
</template>

<script>
// import hdTit from './modulTitle';
import echarts from 'echarts';
export default {
    props: {
        listData: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            myChart: null
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.myChart = echarts.init(document.getElementById('lineCharts'), null, {
            devicePixelRatio: 2
        });
        // this.setOption();
    },
    watch: {
        listData(nVal, oVal) {
            const linex = nVal.map((item) => {
                return item.period;
            });
            const v = nVal.map((item) => {
                return item.total;
            });

            this.setOption(linex, v);
        }
    },
    methods: {
        setOption(x, y) {
            var charts = {
                names: ['入住率'],
                lineX: x,
                value: [y]
            };
            var color = ['rgba(242,157,10', 'rgba(255,100,97', 'rgba(139,170,44', 'rgba(23, 255, 243'];
            var lineY = [];

            for (var i = 0; i < charts.names.length; i++) {
                var x = i;

                if (x > color.length - 1) {
                    x = color.length - 1;
                }
                var data = {
                    name: charts.names[i],
                    type: 'line',
                    stack: '总量',
                    color: color[x] + ')',
                    smooth: false,
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 0,
                                        color: color[x] + ', 0.3)'
                                    },
                                    {
                                        offset: 0.8,
                                        color: color[x] + ', 0)'
                                    }
                                ],
                                false
                            ),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    symbol: 'circle',
                    symbolSize: 5,
                    data: charts.value[i]
                };

                lineY.push(data);
            }

            var option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: charts.names,
                    textStyle: {
                        fontSize: 12,
                        color: 'rgb(0,253,255,0.6)'
                    },
                    right: '4%',
                    top: '10%'
                },
                grid: {
                    top: '24%',
                    left: '5%',
                    right: '5%',
                    bottom: '8%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: charts.lineX,
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 14,
                            fontFamily: 'Microsoft YaHei'
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#195384'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: function (value) {
                            if (value >= 1000) {
                                return value / 1000 + 'k';
                            }
                            return value;
                        },
                        textStyle: {
                            color: '#fff',
                            fontSize: 14,
                            fontFamily: 'Microsoft YaHei'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgb(23,255,243,0.3)'
                        }
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: '#27b4c2'
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                series: lineY
            };

            this.myChart.setOption(option, true);
        }
    },
    components: {
        // hdTit
    }
};
</script>
<style scoped lang="scss">
.rightTop {
    position: absolute;
    top: 154px;
    right: 50px;

    .filterBox {
        background: rgba($color: #000000, $alpha: 0.4);
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        -webkit-filter: blur(9px);
        -moz-filter: blur(9px);
        -o-filter: blur(9px);
        -ms-filter: blur(9px);
        filter: blur(30px);
    }
    .trendClass {
        position: relative;
        background: url(../../assets/img/card.png) no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        width: 470px;
        height: 280px;
        margin-top: 10px;
        padding-top: 30px;
        box-sizing: border-box;
        padding: 18px;
    }
}
.title {
    position: absolute;
    background: rgba($color: #00c2ff, $alpha: 0.6);
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    padding: 5px 10px;
    display: inline-block;
}
</style>
